import { getResponseError } from "shared/helpers/view";

import { switchSoundApp } from "shared/redux/slices/profile";
import {
  setBlockedUser,
  setPassword,
  setStatusVerified,
  toggleSendProfile,
} from "shared/redux/slices/profile/settings";

import {
  disableUserProfile,
  getBlockedUsers,
  getVerificationUser,
  updateNotificationsSettings,
  updatePasswordSettings,
  updateSoundSettings,
} from "shared/services/settings";

/**
 * Request blockedUser
 * @param {null|function} cb
 * @return {Function}
 */
export function getBlockedCount(cb = null) {
  return (dispatch) => {
    dispatch(toggleSendProfile(true));
    getBlockedUsers()
      .then((blocked) => {
        const { data } = blocked.data;
        if (!blocked.data.success && !data.items) {
          dispatch(toggleSendProfile(false));
          return false;
        }
        dispatch(setBlockedUser(data?.totalItems));
        if (typeof cb === "function") {
          cb();
        }
      })
      .catch((error) => {
        console.log(error.toString());
        dispatch(toggleSendProfile(false));
      });
  };
}

/**
 * Request Verification user
 * @param {null|function} cb
 * @return {Function}
 */
export function getVerificationStatus(cb = null) {
  return (dispatch) => {
    dispatch(toggleSendProfile(true));
    getVerificationUser()
      .then((status) => {
        const { data } = status.data;
        if (!status.data.success && !data.data) {
          dispatch(toggleSendProfile(false));
          return false;
        }
        dispatch(setStatusVerified(data?.status));
        if (typeof cb === "function") {
          cb();
        }
      })
      .catch((error) => {
        console.log(error.toString());
        dispatch(toggleSendProfile(false));
      });
  };
}

/**
 * Change user password
 * @param {string} dataPassword User dataPassword
 * @param {null|function} cb Success callback function
 * @param {null|function} errorCb Error callback function
 * @returns {(function(*): void)|*}
 */
export const changePasswordSettings = (
  dataPassword,
  cb = null,
  errorCb = null
) => {
  return (dispatch) => {
    updatePasswordSettings(dataPassword)
      .then(({ data }) => {
        if (!data?.success) {
          if (errorCb) {
            errorCb(getResponseError(data, ""));
          }
          return;
        }

        dispatch(setPassword(data.data.password));

        if (cb) {
          cb();
        }
      })
      .catch(({ response }) => {
        if (errorCb) {
          errorCb(getResponseError(response, ""));
        }
      });
  };
};

/**
 * Deactivate user profile
 * @param {{password: string, comment: string}} requestData User password
 * @param {null|function} cb Success callback function
 * @param {null|function} errorCb Error callback function
 * @returns {(function(*): void)|*}
 */
export const deactivateProfileUser = (requestData, cb, errorCb = null) => {
  disableUserProfile(requestData)
    .then(({ data }) => {
      if (!data?.success) {
        if (errorCb) {
          errorCb(getResponseError(data, ""));
        }
        return;
      }
      if (cb) {
        cb();
      }
    })
    .catch(({ response }) => {
      if (errorCb) {
        errorCb(getResponseError(response, ""));
      }
    });
};

/**
 * Change SoundValue Settings
 * @param {string} soundValue user sound settings
 * @param {null|function} cb Success callback function
 * @returns {(function(*): void)|*}
 */

export const changeSoundSettings = (soundValue, cb = null) => {
  return (dispatch) => {
    dispatch(toggleSendProfile(true));
    dispatch(switchSoundApp(soundValue.in_app_sound));
    updateSoundSettings(soundValue)
      .then((value) => {
        if (!value.data.success) {
          dispatch(toggleSendProfile(false));
          return false;
        }

        if (typeof cb === "function") {
          cb();
        }
      })
      .catch((error) => {
        console.log(error.toString());
        dispatch(toggleSendProfile(false));
      });
  };
};

/**
 * Change Notifications  Settings
 * @param {string} notificationsValue user sound settings
 * @param {null|function} cb Success callback function
 * @returns {(function(*): void)|*}
 */

export const changeNotificationsSettings = (notificationsValue, cb = null) => {
  return (dispatch) => {
    dispatch(toggleSendProfile(true));
    updateNotificationsSettings(notificationsValue)
      .then((value) => {
        if (!value.data.success) {
          dispatch(toggleSendProfile(false));
          return false;
        }
        if (typeof cb === "function") {
          cb();
        }
      })
      .catch((error) => {
        console.log(error.toString());
        dispatch(toggleSendProfile(false));
      });
  };
};
